<div class="modal-header">
    <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
    <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0" ngbAutofocus>
    <p class="text-justify">{{msg}}</p>
    <br>
    <p class="text-justify">{{msg2}}</p>
  </div>
      
  